/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";
import { NavLink } from "react-router-dom";
import { checkIsActive } from "../../../../_helpers";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { API, graphqlOperation } from "aws-amplify";
import * as actions from "../../../../../app/modules/Messages/_redux/actions";

export function HeaderMenu({ layoutProps }) {
  const location = useLocation();
  const { user, conversationData } = useSelector(
    (state) => ({
      user: state.auth.user,
      conversationData: state.messaging.conversationData,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  useEffect(() => {
    if (user.providerId) {
      dispatch(actions.getConversationData(user.providerId, user.firstname));
    }
  }, [dispatch, user]);

  const CreateMessageByConversationId = useMemo(
    () => /* GraphQL */ `
      subscription OnCreateMessageByConversationId($conversationId: ID!) {
        onCreateMessageByConversationId(conversationId: $conversationId) {
          id
          conversationId
          conversation {
            type
            title
          }
          author
          body
          type
          content
          isSeen
          seekerId
          seeker {
            firstName
            lastName
          }
          createdAt
          updatedAt
          providerId
          senderId
        }
      }
    `,
    []
  );

  useEffect(() => {
    if (conversationData && !!conversationData.length) {
      const subscriptions = conversationData.map((data) =>
        API.graphql(
          graphqlOperation(CreateMessageByConversationId, {
            conversationId: data.conversationId,
          })
        ).subscribe({
          next: (event) => {
            dispatch(actions.getConversationData(user.providerId));
          },
          error: (error) => {
            console.warn(error);
          },
        })
      );

      return () => {
        subscriptions.map((subscription) => {
          subscription.unsubscribe();
        });
      };
    }
  }, [CreateMessageByConversationId, conversationData, dispatch, user]);

  const getMenuItemActive = (url) => {
    return checkIsActive(location, url) ? "menu-item-active" : "";
  };

  const unReadConversations = useMemo(
    () =>
      conversationData.filter(({ unReadCount }) => !!unReadCount.length).length,
    [conversationData]
  );

  useEffect(() => {
    if (checkIsActive(location, "/messages")) {
      dispatch(actions.getConversationData(user.providerId, user.firstname));
    }
  }, [dispatch, location, user]);

  return (
    <div
      id="kt_header_menu"
      className={`header-menu header-menu-left header-menu-mobile ${layoutProps.ktMenuClasses}`}
      {...layoutProps.headerMenuAttributes}
    >
      {/*begin::Header Nav*/}
      <ul className={`menu-nav ${layoutProps.ulClasses}`}>
        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/dashboard"
          )}`}
        >
          <NavLink className="menu-link" to="/dashboard">
            <span className="menu-text">Dashboard</span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li className={`menu-item  ${getMenuItemActive("/opportunities")}`}>
          <NavLink
            // activeStyle={{
            //   backgroundColor: '#f89534',
            //   color: '#fff',
            // }}
            className="menu-link"
            to="/opportunities"
          >
            <span className="menu-text">Opportunities</span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/contents"
          )}`}
        >
          <NavLink className="menu-link" to="/contents">
            <span className="menu-text">Contents</span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/followers"
          )}`}
        >
          <NavLink className="menu-link" to="/followers">
            <span className="menu-text">Followers</span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/providers-community"
          )}`}
        >
          <NavLink className="menu-link" to="/providers-community">
            <span className="menu-text">Providers Community</span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/messages"
          )}`}
        >
          <NavLink className="menu-link" to="/messages">
            <span className="menu-text">Messages</span>
            {unReadConversations > 0 && (
              <div
                style={{
                  position: "absolute",
                  top: "-6px",
                  right: "-6px",
                  backgroundColor: "red",
                  color: "white",
                  borderRadius: "50%",
                  fontSize: "10px",
                  width: unReadConversations < 100 ? "16px" : "22px",
                  height: "16px",
                  paddingLeft: unReadConversations < 100 ? "0.5rem" : "0.2rem",
                }}
              >
                {unReadConversations < 100 ? unReadConversations : "99+"}
              </div>
            )}
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*begin::1 Level*/}
        <li
          className={`menu-item menu-item-rel ${getMenuItemActive(
            "/special-projects"
          )}`}
        >
          <NavLink className="menu-link" to="/special-projects">
            <span className="menu-text">Special Projects</span>
            {layoutProps.rootArrowEnabled && <i className="menu-arrow" />}
          </NavLink>
        </li>
        {/*end::1 Level*/}

        {/*Classic submenu*/}
      </ul>
      {/*end::Header Nav*/}
    </div>
  );
}
